import React, { useEffect, useState } from 'react';
import FormSection from 'components/sales/formSection/formSectionNew';
import localization from 'assets/localization/localization';
import Regex from 'services/utils/regex/Regex';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import { FormGroup } from 'react-bootstrap';
import TimePicker from 'react-times';
import 'react-times/css/classic/default.css';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import DatePicker from 'components/sales/datePicker/datePicker';
import { handleFormatDate } from 'constants/dateFormat/dateFormat';
import TextAreaInput from 'components/sales/Input/textAreaInput/textAreaInput';
import moment from 'moment';

const MeetingForm = ({
  documentUploadUrl,
  documentUrlData,
  meetingById = null,
  handleValue,
  siteId,
  pocList,
}) => {
  const inputs = {
    poc_list: '',
    other_email: '',
    meeting_date: '',
    meeting_time: `${new Date().getHours()}:${new Date().getMinutes()}`,
    subject: '',
    summary: '',
  };
  const [formData, setData] = useState(inputs);
  const [attachment, setAttachment] = useState(null);
  const [className, setClassName] = useState('empty');

  useEffect(() => {
    const d = handleFormatDate();
    setData({ ...formData, meeting_date: d });
  }, []);

  useEffect(() => {
    if (meetingById !== null) {
      setData({
        ...formData,
        poc_list: meetingById.poc_lists?.[0]?.id,
        other_email: meetingById.other_email,
        meeting_date: meetingById.meeting_date,
        meeting_time: meetingById.meeting_time,
        subject: meetingById.subject,
        summary: meetingById.summary,
      });
      meetingById.summary && setClassName('');
    }
  }, [meetingById]);

  const handleMeetingData = () => {
    if (
      formData.poc_list !== '' &&
      formData.meeting_date !== '' &&
      formData.subject !== '' &&
      formData.summary !== '' &&
      Regex.email.test(formData.other_email)
    ) {
      handleValue({ ...formData, attachment: attachment, site_id: siteId });
    } else 
    {
      // handleValue(null);
      handleValue({ ...formData, attachment: attachment, site_id: siteId });
    }
  };
  useEffect(() => {
    handleMeetingData();
  }, [formData, attachment]);

  const showSecond = true;
  const str = showSecond ? 'HH:mm:ss' : 'HH:mm';

  function onChange(value) {
    const { hour, minute } = value;
    setData({ ...formData, meeting_time: `${hour}:${minute}` });
  }

  const onFocus = () => {
    if (formData.summary.split('').length === 0) {
      setClassName('empty');
    } else {
      setClassName('');
    }
  };

  return (
    <FormSection title={localization.meetingDetails}>
      <div>
      <DropDownInput
        data={pocList}
        label={localization.toName}
        required
        isStarRequired={true}
        value={
          meetingById !== null
            ? meetingById.poc_lists &&
              meetingById.poc_lists[0] &&
              meetingById.poc_lists[0].name
            : ''
        }
        errorMsg={localization.requiredName}
        getIdValue={(val) =>
          setData({
            ...formData,
            poc_list: val.id,
          })
        }
      />
      <ConstantInput
        value={formData?.other_email}
        label={localization.othersEmail}
        regex={Regex.email.test(formData.other_email)}
        type="email"
        errorMsg={localization.emailError}
        handleChange={(value) => setData({ ...formData, other_email: value })}
        required
        isStarRequired={true}
      />
      <DatePicker
        handleChange={(val) => {
          setData({ ...formData, meeting_date: val });
        }}
        value={moment(formData?.meeting_date, 'DD-MM-YYYY').format(
          'DD-MM-YYYY'
        )}
        displayFormat="DD-MM-YYYY"
        returnFormat="DD-MM-YYYY"
        label={localization.selectDate}
        minimumDate={new Date()}
      />
      <FormGroup>
        <TimePicker
          theme="classic"
          timeFormat="hh:mm"
          timeMode={24}
          time={formData?.meeting_time}
          onTimeChange={onChange}
        />
        <label>{localization.selectTime}</label>
        <label className="error date_error">{localization.isRequired}</label>
      </FormGroup>
      <ConstantInput
        value={formData?.subject}
        label={localization.subject}
        errorMsg={localization.enterSubject}
        type="text"
        required
        isStarRequired={true}
        fullWidth
        handleChange={(value) => setData({ ...formData, subject: value })}
      />
      <TextAreaInput
        inputValue={formData?.summary}
        value={formData?.summary}
        type="text"
        rows={4}
        onFocus={onFocus}
        onBlur={() => {
          if (formData?.summary) setClassName('');
          else setClassName('empty');
        }}
        className={`${className} inline-css scrollbar-styling`}
        // regex={Regex.text.test(formData.summary)}
        label={localization.body}
        errorMsg={localization.isRequired}
        required
        isStarRequired={true}
        fullWidth
        handleChange={(e) => {
          setData({ ...formData, summary: e.target.value });
          e.target.value !== '' && setClassName('');
        }}
      />
      <FormGroup>
        <FileUpload
          id="uploadAttachment"
          accept=".pdf,.png,.jpg"
          documentUploadUrl={documentUploadUrl}
          documentUrlData={documentUrlData}
          onChange={(val) => setAttachment(val)}
        >
          <span className="btn btn-transparent">
            {localization.uploadAttachment}
          </span>
        </FileUpload>
      </FormGroup>
      </div>
    </FormSection>
  );
};

MeetingForm.propTypes = {};

export default MeetingForm;
